"use client";

import { useId } from "react";
import Link from "next/link";
import { badgeVariants } from "~/components/ui/badge";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "~/components/ui/hover-card";
import type { PracticeBadgeData } from "~/lib/practice-page-links";

export function PracticeBadge({
  label,
  href,
  example,
  description,
  variant = "default",
}: PracticeBadgeData & {
  variant?: "default" | "outline";
  description?: string;
}) {
  const exampleId = useId();
  return (
    <HoverCard openDelay={200} closeDelay={150}>
      <HoverCardTrigger asChild>
        <Link
          href={href}
          prefetch={false}
          aria-describedby={example ? exampleId : undefined}
          className={badgeVariants({
            variant,
            className: "text-left whitespace-normal hover:underline",
          })}
        >
          {label}
        </Link>
      </HoverCardTrigger>
      {example && (
        <span id={exampleId} className="sr-only">
          Primer: {example}
        </span>
      )}
      <HoverCardContent align="start" className="w-72 max-w-[calc(100vw-2rem)]">
        {description && (
          <p className="mb-3 text-sm leading-relaxed">{description}</p>
        )}
        {example && (
          <>
            <p className="text-muted-foreground mb-1 text-xs font-semibold">
              Primer
            </p>
            <p className="text-sm leading-relaxed">{example}</p>
          </>
        )}
        <Link
          href={href}
          prefetch={false}
          className="text-primary mt-3 inline-block text-sm font-medium underline underline-offset-4"
        >
          Pogledaj više
        </Link>
      </HoverCardContent>
    </HoverCard>
  );
}
